import type { DetailedIntelligence } from '../types';

// Sample intelligence data from backend output
export const sampleIntelligence: DetailedIntelligence = {
  content_type: "meeting",
  total_segments_processed: 174,
  processed_at: "2025-08-19T22:05:19.640894",
  executive_summary: "-",
  key_topics: [
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor"
  ],
  action_items: [
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "high",
      timestamp_start: "00:01:19.92",
      timestamp_end: "00:02:20.32"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "medium",
      timestamp_start: "00:02:58.48",
      timestamp_end: "00:04:02.80"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "low",
      timestamp_start: "00:05:21.12",
      timestamp_end: "00:06:23.92"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "high",
      timestamp_start: "00:06:10.88",
      timestamp_end: "00:07:12.96"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "medium",
      timestamp_start: "00:06:56.72",
      timestamp_end: "00:08:00.88"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "high",
      timestamp_start: "00:08:34.72",
      timestamp_end: "00:09:35.12"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "medium",
      timestamp_start: "00:08:34.72",
      timestamp_end: "00:09:35.12"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "low",
      timestamp_start: "00:09:23.84",
      timestamp_end: "00:10:44.96"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "low",
      timestamp_start: "00:10:09.12",
      timestamp_end: "00:11:11.36"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "medium",
      timestamp_start: "00:10:54.96",
      timestamp_end: "00:12:11.52"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "low",
      timestamp_start: "00:11:40.32",
      timestamp_end: "00:12:41.52"
    },
    {
      task: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      deadline: '',
      assigned_to: '',
      confidence: "low",
      timestamp_start: "00:13:27.20",
      timestamp_end: "00:14:29.28"
    }
  ],
  decisions: [
    {
      decision: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:05:21.12",
      timestamp_end: "00:06:23.92",
      confidence: "low",
    },
    {
      decision: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:06:10.88",
      timestamp_end: "00:07:12.96",
      confidence: "low",
    }
  ],
  issues: [
    {
      issue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:05:21.12",
      timestamp_end: "00:06:23.92"
    },
    {
      issue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:06:10.88",
      timestamp_end: "00:07:12.96"
    },
    {
      issue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:10:09.12",
      timestamp_end: "00:11:11.36"
    },
    {
      issue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:12:33.60",
      timestamp_end: "00:13:36.00"
    },
    {
      issue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:13:27.20",
      timestamp_end: "00:14:29.28"
    }
  ],
  questions: [
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:05:21.12",
      timestamp_end: "00:06:23.92"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:06:10.88",
      timestamp_end: "00:07:12.96"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:06:56.72",
      timestamp_end: "00:08:00.88"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:07:44.80",
      timestamp_end: "00:08:46.48"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:07:44.80",
      timestamp_end: "00:08:46.48"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:08:34.72",
      timestamp_end: "00:09:35.12"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:08:34.72",
      timestamp_end: "00:09:35.12"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:10:09.12",
      timestamp_end: "00:11:11.36"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:10:09.12",
      timestamp_end: "00:11:11.36"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:11:40.32",
      timestamp_end: "00:12:41.52"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:12:33.60",
      timestamp_end: "00:13:36.00"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:12:33.60",
      timestamp_end: "00:13:36.00"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:13:27.20",
      timestamp_end: "00:14:29.28"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:13:27.20",
      timestamp_end: "00:14:29.28"
    },
    {
      question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      timestamp_start: "00:14:23.04",
      timestamp_end: "00:15:21.84"
    }
  ],
  confidence_note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor"
};
